import { css } from "@emotion/css";
import React, { Key } from "react";
import {
  Menu as AriaMenu,
  MenuProps as AriaMenuProps,
} from "react-aria-components";

export interface MenuProps extends AriaMenuProps<React.ReactElement> {
  children: React.ReactElement | React.ReactElement[];
  onItemAction?: (key: Key) => void;
}

export function Menu(props: MenuProps) {
  const { children, onItemAction, ...rest } = props;
  return (
    <AriaMenu {...rest} className={styles.menu} onAction={onItemAction}>
      {children}
    </AriaMenu>
  );
}

const styles = {
  menu: css({
    padding: 0,
    margin: 0,
    outline: "none",
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-1)",
  }),
};
